<template>
  <div class="history-box">
  <el-dialog
      :visible="dialogVisible"
      @close="close"
    >
      <div class="history-page">
        <div class="history-head">历史记录</div>
        <div class="history-input"><el-input v-model="input" placeholder="请输入关键词搜索" @keyup.enter.native="getPlaneErrorRecord(true)" ></el-input></div>
        <div class="history-ul" @scroll="load($event)">
          <div class="history-li" v-for="(item,index) in errorRecordList" :value="item" :key="index" >
            <div class="history-top">
              <div class="history-text">
                <div class="history-h">{{item.fullFaultMessage}}</div>
                <div class="history-p">{{item.createTimeFormat}}</div>
              </div>
              <div class="history-bt" @click="goMalfunction(item)">进入查看</div>
            </div>
            <div class="history-bottom">
              <div class="history-laber">
                <div class="history-left">记录状态</div>
                <div v-if="item.lastResult==='R1'" class="history-right green">{{item.lastResultComment}}</div>
                <div v-if="item.lastResult==='R2'" class="history-right red">{{item.lastResultComment}}</div>
                <div v-if="item.lastResult==='R3'" class="history-right yellow">{{item.lastResultComment}}</div>
                <div v-if="item.lastResult==='R4'" class="history-right blue">公司决策</div>
              </div>
              <div class="history-laber">
                <div class="history-left">记录编号</div>
                <div class="history-right">{{item.id}}</div>
              </div>
              <div class="history-laber">
                <div class="history-left">飞机类型</div>
                <div class="history-right">{{item.planeType}}</div>
              </div>
              <div class="history-laber">
                <div class="history-left">航班号</div>
                <div class="history-right">{{item.flightNo}}</div>
              </div>
              <div class="history-laber">
                <div class="history-left">飞机编号</div>
                <div class="history-right">{{item.planeId}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {planeErrorRecordHistory} from "@/api/api";

  export default {
    name: "History",
    props:{
      dialogVisible:{
        default:false
      },
      client:{
        type:String,
        required:true
      },
    },
    data() {
        return {
          input:'CSN',
          errorRecordList:[],
          query:{
            number: 1,
            limit: 10,
          },
          params:{
            orderBy:JSON.stringify([{"name":"id","direction":"DESC"}])
          },
          isScroll:true
        };
    },
    mounted() {
      this.getPlaneErrorRecord()
    },
    methods:{
      close(){
        this.$emit('handle-close')
      },
      goMalfunction(item) {
        if ('ROLE_MECH'===this.client){
          this.$router.push(`/malfunctionMech/${item.id}`)
        }else if ('ROLE_SOC'===this.client){
          this.$router.push(`/malfunction/${item.id}`)
        }
        this.close()
      },
      async getPlaneErrorRecord(search) {
        this.isScroll = false
        if (search){
          this.params.flightNo = this.input === 'CSN' ? null : this.input
          this.query.number = 1
          const res = await planeErrorRecordHistory(this.query,this.params)
          if(res.code === 'A00000' && res.data.length) {
            this.errorRecordList = res.data
            this.isScroll = true
          } else {
            this.errorRecordList = []
          }
        } else {
          const res = await planeErrorRecordHistory(this.query,this.params)
          if(res.code === 'A00000' && res.data.length) {
            this.errorRecordList = [...this.errorRecordList, ...res.data]
            this.isScroll = true
            if(res.data.length < 10){
              this.isScroll = false
              //  this.$message.info('已全部加载完')
            }
          }
        }
        console.log(['this.errorRecordList', this.errorRecordList])
      },
      load(e){
        const sHeight = e.target.scrollHeight
        const sTop = e.target.scrollTop
        const cHeight = e.target.clientHeight
        if(sTop + cHeight + 50 >=  sHeight && this.isScroll) {
          this.morePage()
        }
      },
      morePage() {
        this.query.number++
        this.getPlaneErrorRecord()
      }
    }
  }
</script>

<style lang="less" scoped>
/deep/.el-dialog{
  margin: 0 !important;
  background: #262D40;
  height: 100vh;
  width: 600px;
  border-radius: 0 8px 8px 0;
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    color: #fff;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 20px;
  }
  .el-dialog__headerbtn{
    top: 22px;
  }
}
  .history-head{
    padding: 24px 16px;
    font-size: 24px;
    text-align: left;
    line-height: 20px;
  }
  .history-input{
    background: #131B33;
    width: calc(100% - 32px);
    margin: auto;
    height: 45px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    /deep/.el-input__inner{
      background: none;
      color: #fff;
    }
  }
  .history-bottom{
    padding: 24px;
    .history-laber:last-child{
      margin-bottom: 0;
    }
    .history-laber{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .history-left{
        opacity: 0.87;
        font-size: 14px;
      }
      .history-right{
        opacity: 0.9;
        font-size: 16px;
      }
      .history-right.red{
        color: #E07073;
      }
      .history-right.green{
        color: #8EBF86;
      }
      .history-right.yellow{
        color: #EBA967;
      }
      .history-right.blue{
        color: #2769EC;
      }
    }
  }
  .history-ul{
    padding: 16px;
    border-top: 1px solid #171E2F;
    margin-top: 20px;
    height: calc(100vh - 136px);
    padding-bottom: 0;
    box-sizing: border-box;
    overflow: auto;
    .history-li{
      background: #393F52;
      border: 1px solid #525F89;
      border-radius: 16px;
      margin-bottom: 16px;
      .history-top{
        display: flex;
        padding: 24px;
        justify-content: space-between;
        border-bottom: 1px solid #000000;
        .history-text{
          text-align: left;
          width: 370px;
          .history-h{
            font-size: 16px;
            color: rgba(255, 255, 255, 0.87);
            margin-bottom: 10px;
          }
          .history-p{
            color: rgba(255, 255, 255, 0.7);
            font-size: 12px;
          }
        }
        .history-bt{
          background: #4E5569;
          border-radius: 8px;
          font-size: 14px;
          cursor: pointer;
          padding: 0 20px;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/History.vue